export default __webpack_public_path__ + "static/media/reload-icon.3ab99fe0.svg";